<template>
  <div class="organizer-card"  @click.prevent="$emit('viewOrganizer', organizer.id)">
    <div class="organizer-header">
      <h4 class="organizer-name">{{ organizer.name }} {{ organizer.surname }}</h4>
    </div>

    <div class="organizer-body">
      <img :src="organizer.img_path || defaultAvatar" alt="Organizer" class="organizer-image" />

      <div class="organizer-info">
        <div class="country-badge" v-if="statsCountryCode">
          <span class="country-flag" aria-hidden="true" v-if="countryFlag">{{ countryFlag }}</span>
          <span class="country-code">{{ statsCountryCode }}</span>
        </div>

        <div class="stat-grid">
          <div class="stat-card">
            <span class="stat-label">{{ $t('organizers.stats.competitions') }}</span>
            <span class="stat-value">{{ stats.competitions_count }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { isOwnerOrganizer} from '@/helpers/roleUtils';
import {mapState} from "vuex";

export default {
  name: "OrganizerListCard",
  props: {
    organizer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultAvatar: require("@/assets/user.png"),
    };
  },
  computed:{
    ...mapState('user', ['user']),
    stats() {
      const normalize = (value) => {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
      };
      const base = this.organizer?.stats || {};
      return {
        country_code: (base.country_code || this.organizer?.country || '').toUpperCase(),
        competitions_count: normalize(base.competitions_count),
      };
    },
    statsCountryCode() {
      return this.stats.country_code;
    },
    countryFlag() {
      return this.statsCountryCode ? this.codeToFlag(this.statsCountryCode) : '';
    }
  },
  methods: {
    isOwnerOrganizer,
    codeToFlag(code = '') {
      if (!code || code.length < 2) {
        return '';
      }
      const letters = code
          .toUpperCase()
          .replace(/[^A-Z]/g, '')
          .slice(0, 2);
      if (letters.length < 2) {
        return '';
      }
      return letters
          .split('')
          .map(char => String.fromCodePoint(127397 + char.charCodeAt(0)))
          .join('');
    }
  }
};
</script>

<style scoped>
.organizer-card {
  background-color: white;
  border-radius: 10px;
  padding: 0;
  overflow: hidden;
  margin-bottom: 16px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: box-shadow 0.3s ease;
  cursor: pointer;
}

.organizer-card:hover {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
}

/* 🔹 Header */
.organizer-header {
  background-color: #f7f7f7;
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.organizer-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 🔸 Cuerpo con imagen e info */

.organizer-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px;
}

.organizer-image {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
}

.organizer-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.country-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 999px;
  background-color: #f5f7fa;
  border: 1px solid #e0e6ed;
  width: fit-content;
}

.country-flag {
  font-size: 18px;
  line-height: 1;
  /* Emoji-capable stack so flags render across platforms (incl. Windows) */
  font-family: "Twemoji Mozilla", "Noto Color Emoji", "Segoe UI Emoji", "Apple Color Emoji", "Segoe UI", system-ui, sans-serif;
}

.country-code {
  font-size: 12px;
  letter-spacing: 0.08em;
}

.stat-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.stat-card {
  flex: 1;
  min-width: 140px;
  background-color: #fafafa;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  text-align: center;
}

.stat-value {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  text-align: center;
}


@media (max-width: 576px) {
  .organizer-body {
    text-align: center;
  }

  .organizer-image {
    width: 80px;
    height: 80px;
  }

  .stat-grid {
    flex-direction: column;
  }
}

</style>
